import { css } from '@emotion/react';

const typography = (fontSize: number, fontWeight: number) => css`
  font-size: ${fontSize}px;
  font-weight: ${fontWeight};
`;

/**
 * `_app`의 공통 UI가 디자인 시스템 전체 barrel을 로드하지 않도록 필요한 토큰만 둔다.
 * 값은 chatie-design-system 0.1.5의 foundation/typography와 동일하다.
 */
export const AppSpacing = {
  xsmall: 8,
  small: 12,
  medium: 16,
  xlarge: 24,
} as const;

export const AppRadius = {
  small: 5,
  medium: 9,
} as const;

export const AppFontSizes = {
  small: 14,
} as const;

export const AppTypography = {
  h1: typography(24, 700),
  h2: typography(22, 700),
  h3: typography(20, 700),
  h4: typography(18, 700),
  h5: typography(16, 600),
  h6: typography(14, 600),
  body14: typography(14, 400),
} as const;
